import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ShieldMore({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12.177 11.323C12.267 11.413 12.267 11.573 12.177 11.673C12.077 11.763 11.917 11.763 11.817 11.673C11.717 11.573 11.717 11.413 11.817 11.313C11.907 11.213 12.067 11.213 12.167 11.313M16.17 11.323C16.26 11.413 16.26 11.573 16.17 11.673C16.07 11.763 15.91 11.763 15.81 11.673C15.71 11.573 15.71 11.413 15.81 11.313C15.9 11.213 16.06 11.213 16.16 11.313M8.177 11.323C8.267 11.413 8.267 11.573 8.177 11.673C8.077 11.763 7.917 11.763 7.817 11.673C7.717 11.573 7.717 11.413 7.817 11.313C7.907 11.213 8.067 11.213 8.167 11.313M20 11.182C20 15.723 16.58 19.969 12 21C7.413 19.96 4 15.72 4 11.182V7.232C4 6.412 4.49 5.682 5.15 5.412L10.15 3.366C11.36 2.866 12.62 2.866 13.75 3.326L18.75 5.366C19.5 5.666 19.99 6.396 19.99 7.217V11.157L20 11.182Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default ShieldMore;